import React from 'react';
import { Grid, GridItem } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { UnitQueueView } from '@mark43/cad-api';
import { WorkspaceQueue } from '../../panels/workspace-queue';
import { FrUnitsCompactQueueCell } from './fr-compact-queue-cell';

export const FrUnitsCompactQueueRow = observer(function FrUnitsCompactQueueRow({
    data,
    index,
    queueColumns,
}: {
    data: UnitQueueView;
    queueColumns: WorkspaceQueue['queueColumns'];
    index: number;
}): React.ReactElement {
    return (
        <Grid
            position="relative"
            data-testid={`fr-unit-queue-row-${data.id}`}
            data-row-index={index}
            borderBottom="1px solid"
            borderColor="border.default"
            gridTemplateColumns="var(--columns)"
        >
            {queueColumns.map((col) => (
                <GridItem key={col.id}>
                    <FrUnitsCompactQueueCell data={data} column={col} />
                </GridItem>
            ))}
        </Grid>
    );
});
